import axios, { AxiosResponse } from 'axios';
import { isValidWorkyServerResponseWithData } from '../common/WorkyAPIUtils';
import type {
    RegistrationInviteLookupRequestDto,
    RegistrationInviteLookupResponseDto,
} from './WorkyRegistrationInterfaces';

const REGISTRATION_RESOLVE_INVITE_API_PATH: string = 'auth/registration/resolve-invite/';
const backendApiBasePathLocal: string = process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL ?? '';

const resolveRegistrationInvite = async (
    requestBody: RegistrationInviteLookupRequestDto
): Promise<RegistrationInviteLookupResponseDto | null> => {
    try {
        const apiResponse: AxiosResponse<
            { readonly data?: RegistrationInviteLookupResponseDto }
        > = await axios.post(`${backendApiBasePathLocal}${REGISTRATION_RESOLVE_INVITE_API_PATH}`, requestBody, {
            headers: { 'Content-Type': 'application/json' },
        });

        if (!isValidWorkyServerResponseWithData(apiResponse)) {
            console.error('Registration invite lookup response missing data', apiResponse?.data);
            return null;
        }

        return apiResponse.data.data ?? null;
    } catch (error: unknown) {
        console.error('Registration invite lookup failed', error);
        return null;
    }
};

export { resolveRegistrationInvite };
